module.exports = __webpack_public_path__ + "img/cheeks_female_high.f0dac0cc.png";